// Post / media / text utilities

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function resolveMediaUrl(url) {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  if (url.startsWith('/api/')) return `${BACKEND}${url}`;
  return url;
}

export const CATEGORIES = [
  'aura_moment', 'sports', 'style', 'creativity', 'social', 'humor',
  'dance', 'music', 'achievement', 'positive_action', 'family', 'school',
  'community', 'gaming', 'other',
];

export const REPORT_REASONS = [
  'harassment', 'threats', 'hate_speech', 'sexual_content', 'violence',
  'spam', 'aura_fraud', 'impersonation', 'privacy', 'minor_content', 'other',
];

export const REACTIONS = [
  { key: 'aura',    icon: '⚡', label: '+AURA',   color: '#00F0FF' },
  { key: 'fire',    icon: '🔥', label: 'FIRE',    color: '#FF6B00' },
  { key: 'respect', icon: '👏', label: 'RESPECT', color: '#FFE800' },
  { key: 'king',    icon: '👑', label: 'KING',    color: '#B026FF' },
  { key: 'legend',  icon: '💯', label: 'LEGEND',  color: '#FF2E9F' },
];

export function relativeTime(iso, locale = 'es') {
  if (!iso) return '';
  const now = new Date();
  const then = new Date(iso);
  const diff = Math.max(0, (now - then) / 1000);
  const en = locale === 'en';
  if (diff < 60) return en ? 'just now' : 'ahora';
  if (diff < 3600) return en ? `${Math.floor(diff / 60)}m` : `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d`;
  return then.toLocaleDateString(locale === 'en' ? 'en-US' : 'es-MX', { month: 'short', day: 'numeric' });
}

/** Split caption into React nodes with hashtags + mentions as links. */
export function renderCaption(text, { onTag, onMention } = {}) {
  if (!text) return null;
  const re = /(#[A-Za-z0-9_]{2,30}|@[A-Za-z0-9_]{3,24})/g;
  const parts = String(text).split(re);
  return parts.map((p, i) => {
    if (!p) return null;
    if (p.startsWith('#')) {
      const tag = p.slice(1);
      return (
        <a key={i} href={`/tag/${tag}`} onClick={(e) => { if (onTag) { e.preventDefault(); onTag(tag); } }} className="text-aura-cyan hover:underline">
          {p}
        </a>
      );
    }
    if (p.startsWith('@')) {
      const u = p.slice(1);
      return (
        <a key={i} href={`/u/${u}`} onClick={(e) => { if (onMention) { e.preventDefault(); onMention(u); } }} className="text-aura-violet hover:underline">
          {p}
        </a>
      );
    }
    return <React.Fragment key={i}>{p}</React.Fragment>;
  });
}

// eslint-disable-next-line
import React from 'react';
